import DOMPurify from "dompurify";
import { twMerge } from "tailwind-merge";
import type { TRecurrenceButton } from "./types";
import { recurrenceVariants } from "./variables";

export const RecurrenceButton = ({
  active,
  text,
  discount,
  onClick,
  size = "default",
}: TRecurrenceButton) => {
  const { wrapperClass, textClass } =
    recurrenceVariants[active ? "active" : "inactive"];

  const baseClass =
    "inline-flex items-center justify-center text-center transition duration-150 rounded-md cursor-pointer disabled:cursor-default";

  const defaultClass =
    "py-1.5 px-3 md:justify-center md:w-37.5 xl:w-45 gap-1.5";

  const compactClass =
    "px-1 py-2 md:px-3 md:py-1.5 gap-1 w-fit md:w-full text-sm md:justify-center";

  const RecurrenceButtonElement = document.createElement("button");
  RecurrenceButtonElement.type = "button";
  RecurrenceButtonElement.disabled = active;

  RecurrenceButtonElement.className = twMerge(
    baseClass,
    wrapperClass,
    size === "compact" ? compactClass : defaultClass,
  );

  if (size === "compact") {
    RecurrenceButtonElement.style.display = "inline-flex";
    RecurrenceButtonElement.style.justifyContent = "center";
    RecurrenceButtonElement.style.alignItems = "center";
    // RecurrenceButtonElement.style.padding = "6px 12px";
    RecurrenceButtonElement.style.gap = "6px";
  }

  const titleClasses = twMerge(
    "inline align-middle leading-none text-sm font-medium text-gray-500",
    textClass,
  );

  const badge =
    typeof discount === "number"
      ? DOMPurify.sanitize(`
        <span class="!inline-flex shrink-0 align-middle whitespace-nowrap rounded-md px-1.5 text-[.625rem] leading-none items-center font-semibold py-1 bg-yellow-700 text-blue-800">
          ${discount}% OFF
        </span>
      `)
      : "";

  RecurrenceButtonElement.innerHTML = DOMPurify.sanitize(`
    <span class="inline-flex items-center gap-1.5 whitespace-nowrap md:whitespace-normal">
      <span id="text-recurrence-button" class="${titleClasses}">${text}</span>
      ${badge}
    </span>
  `);

  RecurrenceButtonElement.addEventListener("click", (e) => onClick(e));

  return RecurrenceButtonElement;
};
